import { Box, Typography } from '@mui/material';

import { useT } from '@/hooks';
import { PrivyOtpVerification, WalletLinkState } from '../modal';

interface InitializingViewProps {
  isInitializingPrivy: boolean;
}

export const InitializingView = () => {
  const { t } = useT();
  return (
    <Box className="flex flex-1 flex-col items-center justify-center gap-6 p-14">
      <Box className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--border-light)] border-t-[var(--accent-blue)]" />
      <Box className="text-center">
        <Typography variant="h6" className="mb-2 font-bold text-[var(--text-primary)]">
          {t('depositModal.initializingSession')}
        </Typography>
        <Typography variant="body2" className="text-[var(--text-secondary)]">
          {t('depositModal.settingUpWallet')}
        </Typography>
      </Box>
    </Box>
  );
};

interface DepositStatusViewsProps {
  isInitializingPrivy: boolean;
  isOtpSent: boolean;
  authenticated: boolean;
  userEmail?: string;
  otpCode: string;
  setOtpCode: (val: string) => void;
  isAuthenticating: boolean;
  handleVerify: () => void;
  handleResend: () => void;
  linkStatus: { isError: boolean; isLinking: boolean };
  link: () => void;
  children: React.ReactNode;
}

export const DepositStatusViews = ({
  isInitializingPrivy,
  isOtpSent,
  authenticated,
  userEmail,
  otpCode,
  setOtpCode,
  isAuthenticating,
  handleVerify,
  handleResend,
  linkStatus,
  link,
  children,
}: DepositStatusViewsProps) => {
  if (isInitializingPrivy) {
    return <InitializingView />;
  }

  if (isOtpSent && !authenticated) {
    return (
      <PrivyOtpVerification
        email={userEmail}
        otpCode={otpCode}
        setOtpCode={setOtpCode}
        isAuthenticating={isAuthenticating}
        onVerify={handleVerify}
        onResend={handleResend}
      />
    );
  }

  if (linkStatus.isError || linkStatus.isLinking) {
    return (
      <WalletLinkState
        isError={linkStatus.isError}
        isLinking={linkStatus.isLinking}
        onRetry={link}
      />
    );
  }

  return <>{children}</>;
};
